/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: c57bc44fe499
 */

import * as z from "zod";

export type TransformationSummary = {
  name?: string | undefined;
  allowed_for_strict?: boolean | undefined;
  used?: boolean | undefined;
  named?: boolean | undefined;
};

export const TransformationSummary$zodSchema: z.ZodType<TransformationSummary> =
  z.object({
    allowed_for_strict: z.boolean().optional(),
    name: z.string().optional(),
    named: z.boolean().optional(),
    used: z.boolean().optional(),
  });
